import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
    { id: "accueil", label: "Accueil" },
    { id: "a-propos", label: "À propos" },
    { id: "services", label: "Services" },
    { id: "temoignages", label: "Témoignages" },
    { id: "contact", label: "Contact" },
];

export default function Navbar() {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        onScroll();
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const handleNav = (id) => {
        setOpen(false);
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <header
            data-testid="site-navbar"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "backdrop-blur-xl bg-cream/85 border-b border-line/60"
                    : "bg-transparent"
            }`}
        >
            <nav className="max-w-6xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
                <button
                    data-testid="nav-logo"
                    onClick={() => handleNav("accueil")}
                    className="font-serif text-2xl md:text-[28px] tracking-tight text-ink hover:text-rose-700 transition-colors"
                >
                    Cindy <span className="italic text-rose-700">Bien-Naître</span>
                </button>

                <ul className="hidden md:flex items-center gap-10">
                    {NAV_LINKS.map((link) => (
                        <li key={link.id}>
                            <button
                                data-testid={`nav-link-${link.id}`}
                                onClick={() => handleNav(link.id)}
                                className="text-sm tracking-wide text-ink-soft hover:text-rose-700 transition-colors duration-300 relative group"
                            >
                                {link.label}
                                <span className="absolute -bottom-1 left-0 w-0 h-px bg-rose-700 transition-all duration-300 group-hover:w-full" />
                            </button>
                        </li>
                    ))}
                </ul>

                <button
                    data-testid="nav-mobile-toggle"
                    className="md:hidden text-ink"
                    onClick={() => setOpen((v) => !v)}
                    aria-label="Menu"
                >
                    {open ? <X size={24} /> : <Menu size={24} />}
                </button>
            </nav>

            {open && (
                <div
                    data-testid="nav-mobile-panel"
                    className="md:hidden bg-cream border-t border-line"
                >
                    <ul className="px-6 py-6 flex flex-col gap-5">
                        {NAV_LINKS.map((link) => (
                            <li key={link.id}>
                                <button
                                    data-testid={`nav-link-mobile-${link.id}`}
                                    onClick={() => handleNav(link.id)}
                                    className="font-serif text-2xl text-ink hover:text-rose-700"
                                >
                                    {link.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </header>
    );
}
